import { render, staticRenderFns } from "./SummaryAnalyzeBox.vue?vue&type=template&id=3b85fb65&scoped=true&"
import script from "./SummaryAnalyzeBox.vue?vue&type=script&lang=js&"
export * from "./SummaryAnalyzeBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b85fb65",
  null
  
)

export default component.exports